/**
 * How an agent's status reads on screen: a coloured dot and a word. Same
 * colours as the Organisation chart's cards. Used by the agent header and
 * the Subagents tab so both say it the same way.
 */
const STATUS_LOOK: Record<string, { dot: string; label: string }> = {
  active: { dot: "bg-success", label: "Active" },
  running: { dot: "bg-success", label: "Working" },
  idle: { dot: "bg-text-muted", label: "Idle" },
  paused: { dot: "bg-warning", label: "Paused" },
  pending_approval: { dot: "bg-warning", label: "Waiting for approval" },
  error: { dot: "bg-danger", label: "Error" },
  terminated: { dot: "bg-danger", label: "Stopped" },
};

export function agentStatusLook(status: string): { dot: string; label: string } {
  return (
    STATUS_LOOK[status] ?? {
      dot: "bg-text-muted",
      label: status.charAt(0).toUpperCase() + status.slice(1),
    }
  );
}
